import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  Text,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from 'recharts';
import { Translate } from 'react-i18nify';
import CustomizedTooltip from '../../charts/CustomizedTooltip';

const styles = theme => ({
  noResults: {
    color: 'rgba(0,0,0,0.5)',
    fontSize: '12px',
    lineHeight: '14px',
    textTransform: 'uppercase',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

const CustomizedYAxisTick = ({ x, y, stroke, payload, textWidth = 150 }) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <Text
        width={textWidth}
        fontSize="12"
        x={0}
        y={0}
        dy={2}
        textAnchor="end"
        fill="#606060"
      >
        {payload.value}
      </Text>
    </g>
  );
};

const CustomizedXAxisTick = ({ x, y, stroke, payload }) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <Text
        width={30}
        fontSize="12"
        x={0}
        y={0}
        dy={20}
        textAnchor="middle"
        fill="#606060"
      >
        {payload.value}
      </Text>
    </g>
  );
};

const BarComponent = ({
  classes,
  data,
  yKey = 'name',
  xKey = 'count',
  barSize = 32,
  height = 400,
  width = 600,
  textWidth = 150,
  dashboard = false,
  dashGraph = '',
  barLeftMargin = 105,
  units,
}) => {
  if (dashboard) {
    let total = 0;
    let tmp = { key: 'Other Apps', doc_count: 0 };
    let graphData = [];
    let dataPts = [];

    if (dashGraph === 'process') {
      dataPts = ['Chrome', 'Firefox', 'Edge', 'Safari'];
    }
    if (dashGraph === 'tls') {
      dataPts = ['TLS 1.0', 'TLS 1.2'];
    }
    if (dashGraph === 'protocol') {
      dataPts = ['HTTP', 'HTTPS'];
    }
    data.map((entry, index) => {
      total += entry.doc_count;
      if (dataPts.includes(entry.key)) {
        graphData.push(entry);
      } else {
        tmp.doc_count += entry.doc_count;
      }
      return entry;
    });
    if (tmp.doc_count > 0 && dashGraph == 'process') {
      graphData.push(tmp);
    }

    data = graphData;
  }

  return (
    <ResponsiveContainer height={height} width={width}>
      {data.length > 0 ? (
        <BarChart
          width={width}
          height={height}
          data={data}
          margin={{ left: barLeftMargin, bottom: 15, right: 10 }}
          barSize={barSize}
          layout="vertical"
        >
          <CartesianGrid horizontal={false} />
          <XAxis type="number" tick={<CustomizedXAxisTick />} />
          <YAxis
            interval={0}
            axisLine={false}
            type="category"
            tickLine={false}
            tick={<CustomizedYAxisTick textWidth={textWidth} />}
            dataKey={yKey}
          />
          <Tooltip content={<CustomizedTooltip units={units} />} />
          <Bar dataKey={xKey} fill="#0088CE" />
        </BarChart>
      ) : (
        <div className={classes.noResults}>
          <Translate value="shared.noResults" />
        </div>
      )}
    </ResponsiveContainer>
  );
};

BarComponent.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      count: PropTypes.number,
      name: PropTypes.string,
    })
  ).isRequired,
};

export default withStyles(styles, { name: 'AreaChart' })(BarComponent);
